

import { Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as bie from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { viewImage } from "../CommonUtils/viewImage";
import { BsEyeFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { FaCheck } from "react-icons/fa";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import Alert from 'react-bootstrap/Alert';
import CommonFormHeading from "../CommonUtils/CommonFormHeading";

export default function AffiliationApplicationCategory() {
    const acYear = sessionStorage.getItem('ac_year');
    const userId = sessionStorage.getItem('user_id');
    const hasFetchedData = useRef(false);
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const afflApplicationCategoryformik = useFormik({
        initialValues: {
            chk_1: ""
        },
        enableReinitialize: true,
        onSubmit: (val) => {
            Swal.fire({
                title: "Are you sure want to submit the data?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Submit",
                cancelButtonText: "Cancel",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let saveUrl = config.url.API_URL + `applicationSubmission `
                    CommonAxiosPost(saveUrl, val, dispatch).then((resAtsave) => {
                        if (resAtsave?.data?.scode === '01') {
                            Swal.fire(resAtsave?.data?.sdesc, '', 'success').then((res) => {
                                if (res?.isConfirmed) {
                                    AffiliationApplicationCategoryGetDetails();
                                }
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    })
    function AffiliationApplicationCategoryGetDetails() {
        let affilCatgurl = config.url.API_URL + "getoveralldata/" + userId;
        CommonAxiosGet(affilCatgurl, dispatch).then((resAyaffilCatgoty) => {
            if (resAyaffilCatgoty?.data !== undefined) {
                setData(resAyaffilCatgoty?.data)
            }
            else {
                setData([])
            }
        })
    }


    useEffect(() => {
        if (!hasFetchedData.current) {
            AffiliationApplicationCategoryGetDetails()
            hasFetchedData.current = true
        }
    }, [])

    const eopData = Array.isArray(data?.eopData) ? data?.eopData[0] : {};
    const eopFile = eopData?.eop_file !== undefined ? eopData?.eop_file : null
    const sanctionsOrderFile = eopData?.sanction_order_file !== undefined ? eopData?.sanction_order_file : null

    return (
        <>            <CommonFormHeading heading={`Application ${acYear} Submission`} />

            <bie.Container fluid className="affl-newdiv px-1" >

                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
                    <FormikProvider value={afflApplicationCategoryformik}>
                        <Form onChange={afflApplicationCategoryformik.handleChange} onSubmit={afflApplicationCategoryformik.handleSubmit} className="form_adjust" >
                            {data?.eopData?.length > 0 && (
                                <>
                                    <div className="inner-herbpage-service-title-sub pt-0"  >
                                        <h1 className="">Details Confirmed by CHE</h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                                            aria-hidden="true">
                                            <tbody style={{ textAlign: "center" }}>
                                                <tr>
                                                    <td>Is the college Running in Leased / Own Accommodation</td>
                                                    <td>{eopData?.coll_accomdation !== undefined ? eopData?.coll_accomdation : null}</td>
                                                    <td>Upload EOP that is Valid for {acYear} (Pdf) </td>
                                                    <td>{<button type='button' onClick={() => viewImage(eopFile)} className='btn btn-primary'><BsEyeFill size={20}></BsEyeFill></button>}</td>
                                                </tr>
                                                <tr>
                                                    <td>Course Conversion Order</td>
                                                    <td>{<button type='button' onClick={() => viewImage(sanctionsOrderFile)} className='btn btn-primary'><BsEyeFill size={20}></BsEyeFill></button>}</td>
                                                    <td>Date of Issuance</td>
                                                    <td>{eopData?.issuance_date !== undefined ? eopData?.issuance_date : null}</td>
                                                </tr>
                                                <tr>
                                                    <td>Can this College be allowed for Applying
                                                        for Affiliation for {acYear}</td>
                                                    <td>{eopData?.affiliation_allow_apply !== undefined ? eopData?.affiliation_allow_apply : null}</td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                            {data?.pgCourses?.length > 0 ? <>
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Affiliation Order {acYear} PG Courses </h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Course Category</th>
                                                <th>Specialization</th>
                                                <th>Medium</th>
                                                <th>Intake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.pgCourses && data?.pgCourses?.map((pgdd, i) => (
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td className="text-left">{pgdd?.course_cat_name}</td>
                                                    <td className="text-left">{pgdd?.course_name}</td>
                                                    <td>{pgdd?.medium}</td>
                                                    <td>{pgdd?.intake}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </> : null}
                            {data?.ugCourses?.length > 0 ? <>
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Single Major Programmes Santioned By CHE {acYear}</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Single Major Programme</th>
                                                <th>Regular/Self-Financed</th>
                                                <th>Medium</th>
                                                <th>Intake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.ugCourses && data?.ugCourses?.map((ugdd, i) => (
                                                <tr>
                                                    <td className="cen">{i + 1}</td>
                                                    <td className="text-left">{ugdd?.course_details}</td>
                                                    <td>{ugdd?.reg_self}</td>
                                                    <td>{ugdd?.medium}</td>
                                                    <td>{ugdd?.intake}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </> : ''}
                            {data?.labdata?.length > 0 ? <>
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Details of Laboratories {acYear}</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Single Major Programme</th>
                                                <th>Lab</th>
                                                <th>Lab Name</th>
                                                <th>Lab Image</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            {data?.labdata && data?.labdata?.map((labdd, i) => (
                                                <tr>
                                                    <td className="cen">{i + 1}</td>
                                                    <td className="text-left">{labdd?.course_details}</td>
                                                    <td>{labdd?.lab_nonlab}</td>
                                                    <td className="text-left">{labdd?.lab_details}</td>
                                                    <td>
                                                        {
                                                            labdd?.building_img === "nodata" ? "Image Not Uploaded Yet" :
                                                                <button type='button' onClick={() => viewImage(labdd?.building_img)} className='btn btn-primary'><BsEyeFill size={20}></BsEyeFill></button>}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </> : null}
                            {data?.uploadsData?.length > 0 ? <>
                                <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Document Uploads</h1>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Document Type</th>
                                                <th>Document Description</th>
                                                <th>Document Date</th>
                                                <th>Uploaded Document</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {data?.uploadsData && data?.uploadsData?.map((documentdd, i) => (
                                                <tr>
                                                    <td className="cen">{i + 1}</td>
                                                    <td className="text-left">{documentdd?.doc_name}</td>
                                                    <td className="text-left">{documentdd?.doc_descrption}</td>
                                                    <td>{documentdd?.doc_uploading_date}</td>
                                                    {/* <td className="text-center">{<button type='button' onClick={() => viewImage(documentdd?.doc_uploading)} className=''><BsEyeFill size={20}></BsEyeFill></button>}</td> */}



                                                    <td>
                                                        <b
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={() => viewImage(documentdd?.doc_uploading)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    viewImage(documentdd?.doc_uploading);
                                                                }
                                                            }}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <BsEyeFill size={20} />
                                                        </b>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </> : null}

                            {data?.lab === 1 && data?.sub === 1 && data?.submitcount !== 1 && data?.collegeApprovals == 1 && (<>
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Field type="checkbox" name="chk_1" /> &nbsp;
                                        I hereby apply for Affiliation {acYear} for the Courses Sanctioned by Competent Authority
                                    </bie.Col>
                                </bie.Row>
                                {afflApplicationCategoryformik?.values?.chk_1 === true ?
                                    <div className="d-grid gap-2 button-end">
                                        <button type='submit' className='btn btn-success btn-sm float-end mt-2'>Submit</button>
                                    </div> : null}
                            </>)}
                            {data?.lab === 1 && data?.sub === 1 && data?.submitcount === 1 && data?.collegeApprovals === 1 && (
                                (<b className='btn btn-success btn-sm float-end'><FaCheck size="20px" /> Already Submitted</b>)
                            )}
                            {data?.lab === 0 && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Alert variant="danger" className='affl-alert' >
                                            <p className="mb-0">Note: Lab Details Not Yet Confirmed for Lab Courses</p>
                                        </Alert>
                                    </bie.Col>
                                </bie.Row>
                            )}
                            {data?.sub === 0 && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Alert variant="danger" className='affl-alert' >
                                            <p className="mb-0">Note: Teacher Subject Add Not Yet Confirmed</p>
                                        </Alert>
                                    </bie.Col>
                                </bie.Row>
                            )}

                            {data?.collegeApprovals === 0 && (
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Alert variant="danger" className='affl-alert' >
                                            <p className="mb-0">Note: College Approval Details Not Yet Confirmed</p>
                                        </Alert>
                                    </bie.Col>
                                </bie.Row>
                            )}

                        </Form>
                    </FormikProvider >
                </bie.Container>
            </bie.Container>
        </>
    )
}
